import { styled, theme } from '@clickcease/cc-client-components-lib'

const {
  space: {
    '32': { value: space32 },
  },
} = theme

export const PlanFeaturesRowStyled = styled('div', {
  display: 'flex',
  width: '1120px',
  height: space32,
  color: '$black',

  '& div': {
    height: space32,
    display: 'flex',
    alignItems: 'center',
  },
  '> div': {
    borderTop: 'none',
    borderRight: 'none',
    '@bp1': {
      borderLeft: 'none',
    },
  },
  'div:not(:first-child) ': {
    justifyContent: 'center',
  },

  '&:last-of-type > div': {
    borderBottom: 'none',

    '@bp1': {
      borderBottom: 'solid 1px $lightNeutral',
    },
  },

  '@bp1': {
    width: '94%',
    fontSize: '$md',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '@laptop': {
    width: '98%',
  },
})

export const PlanFeaturesRowTitle = styled('div', {
  width: '384px',
  paddingLeft: '$8',
  borderBottom: 'solid 1px $lightNeutral',
  padding: '0px $8',
  justifyContent: 'space-between',

  '> span': {
    marginTop: '$2',
  },

  '@bp1': {
    width: '50%',
  },

  '@laptop': {
    width: '190px',
  },
})
export const PlanFeaturesRowTitleText = styled('div', {})

export const PlanFeaturesRowCell = styled('div', {
  width: '230px',
  textAlign: 'center',
  border: 'solid 1px $lightNeutral',

  '@bp1': {
    width: '33%',
  },
})
